import React from "react";
import { graphql, useStaticQuery } from "gatsby";

import Modal from "../../atoms/modal/modal";
import PhoneBook from "../../atoms/phone-book/phoneBook";

import "./directoryModal.scss";

interface DirectoryModalInterface {
  open: boolean;
  onClose: Function;
}

const DirectoryModal = (props: DirectoryModalInterface) => {
  const { open, onClose } = props;

  const data = useStaticQuery(graphql`
    query QueryDirectoryModal {
      allContentfulHome(filter: { titulo: { eq: "Home bibliotecas" } }) {
        nodes {
          referenciaContenido {
            tipoComponente
            tituloGeneral
            referenciaTabsContenido {
              nombreTab
              referenciaCursosDestacados {
                tituloPrincipal
                redireccionBoton
                textoBoton
              }
            }
          }
        }
      }
    }
  `);

  const contentfulData = data.allContentfulHome.nodes[0].referenciaContenido.find(
    (el) => el.tipoComponente === "ModalDirectorio"
  );

  return (
    <Modal
      open={open}
      onClose={() => onClose()}
      className="m-directory"
      content={"content-mobile"}
    >
      <div className="m-directory__content">
        <button className="icon-close icon-pos" onClick={() => onClose()} />
        <h1 className="m-directory__content__title">Directorio</h1>
        <div className="m-directory__content__paper">
          <div className="m-directory__content__paper__seccion">
            <h2 className="m-directory__content__paper__seccion__title">
              {contentfulData.referenciaTabsContenido[0].nombreTab}
            </h2>
            <div className="m-directory__content__paper__seccion__phone-num">
              {contentfulData.referenciaTabsContenido[0].referenciaCursosDestacados.map(
                (directory, index) => (
                  <PhoneBook directory={directory} key={`directory${index}`} />
                )
              )}
            </div>
          </div>
          <span className="separator" />
          <div className="m-directory__content__paper__seccion">
            <h2 className="m-directory__content__paper__seccion__title">
              {contentfulData.referenciaTabsContenido[1].nombreTab}
            </h2>
            <div className="m-directory__content__paper__seccion__phone-num">
              {contentfulData.referenciaTabsContenido[1].referenciaCursosDestacados.map(
                (directory, index) => (
                  <PhoneBook directory={directory} key={`directory${index}`} />
                )
              )}
            </div>
          </div>
          <span className="separator" />
          <div className="m-directory__content__paper__seccion">
            <h2 className="m-directory__content__paper__seccion__title">
              {contentfulData.referenciaTabsContenido[2].nombreTab}
            </h2>
            <div className="m-directory__content__paper__seccion__phone-num">
              {contentfulData.referenciaTabsContenido[2].referenciaCursosDestacados.map(
                (directory, index) => (
                  <PhoneBook directory={directory} key={`directory${index}`} />
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DirectoryModal;
